module.exports = __webpack_public_path__ + "img/newBanner.effa3e90.jpg";